import CustomTrigger from "components/CustomTrigger";
import { ReactNode } from "react";

type Props = {
  sidebarOpen: boolean;
  toggleSidebar: (toggle: boolean) => void;
  title: string;
  subtitle?: string;
  action?: ReactNode;
};

const AdminHeader = ({ sidebarOpen, toggleSidebar, title, subtitle, action }: Props) => {
  return (
    <header className="sticky top-0 z-5 flex items-center gap-4 border-b border-slate-200 bg-white/95 backdrop-blur-sm p-4 px-8 text-slate-900">
      <CustomTrigger sidebarOpen={sidebarOpen} toggle={toggleSidebar} />
      <div className="flex justify-between w-full items-center">
        <div>
          <h1 className="text-[17px] font-semibold text-slate-900">{title}</h1>
          {subtitle && <p className="text-[13px] text-slate-500 mt-0.5">{subtitle}</p>}
        </div>
        {action}
      </div>
    </header>
  );
};

export default AdminHeader;
